module.exports = __webpack_public_path__ + "static/media/UniNeueThin.0de39417.eot";